import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SystemState {
  snackbar: {
    msg: string;
    isError?: boolean;
    disableAutoHide?: boolean;
  } | null;
  isLoading: boolean;
}

const reducers = {
  showSnackbar: (
    state: SystemState,
    action: PayloadAction<{
      msg: string;
      isError?: boolean;
      disableAutoHide?: boolean;
    } | null>
  ) => {
    state.snackbar = action.payload;
  },
  setIsLoading: (state: SystemState, action: PayloadAction<boolean>) => {
    state.isLoading = action.payload;
  },
  scrollPageToTop: () => {
    document.querySelector("html")?.scrollTo({ top: 0, behavior: "smooth" });
  },
};

const initialState: SystemState = {
  snackbar: { msg: "", isError: false, disableAutoHide: false },
  isLoading: false,
};

export const systemSlice = createSlice({
  name: "system",
  initialState,
  reducers,
});

export const { showSnackbar, setIsLoading, scrollPageToTop } =
  systemSlice.actions;

export default systemSlice.reducer;
